import React from 'react';
import { func } from 'prop-types';

// Components
import ClearIcon from 'dibs-vg/dist/react/close';

// Styles
import styles from './SearchBar-style.scss';

const ClearButton = ({ onClick }) => {
    return (
        <div className={`${styles.button} ${styles.clear}`} onClick={onClick}>
            <div className={`${styles.icon} ${styles.clear}`}>
                <ClearIcon />
            </div>
        </div>
    );
};

ClearButton.propTypes = {
    onClick: func.isRequired,
};

export default ClearButton;
